import React from 'react';
import Button from '../atoms/button';
import styled from 'styled-components';
import I10n from '../features/i10n';

const BackButtonWrapper = styled.div`
  margin-right: 5px;
`;

class BackToList extends React.Component {

  render() {
    return (
      <BackButtonWrapper>
        <Button icon-name="arrow-left" height={'32px'} alternative size="standard" option="outline" onClick={() => { this.props.unselectIsland() }} style={{ fontSize: '10px' }} >
            {I10n.get('screen.config_editor.back_to_list')}
        </Button>
      </BackButtonWrapper>
    );
  }
}


export default BackToList;
